module.exports = __webpack_public_path__ + "img/partnership.153ab172.svg";